import React, { ChangeEvent, useContext } from 'react';
import { Grid, Box, Button } from '@material-ui/core';
import { useTypedTranslation } from '@app/hooks';
import { PasslySelect } from '@app/components/Forms';
import { PROTOCOL_TYPES, PROTOCOL_TYPES_OFFICE365} from '@app/pages/ssoManager/addEditApplication.enums';

import { ProtocolConfigurationForm } from './protocolConfiguration';
import { isSpInit, isIdPInit, isWSFed, isOAuth, isCustomApp } from '@app/helpers/addEditApplication.helpers';

import AppsContext from './appContext';

interface IProps {
    setProtocolConfigError: Function;
    isOffice365: boolean;
}

export const ProtocolConfiguration: React.SFC<IProps> = ({ setProtocolConfigError, isOffice365 }: IProps) => {
    const { translation } = useTypedTranslation();
    const app = useContext(AppsContext);
    const { Protocol, updateState } = app;
    const protocolTypes = isOffice365 ? PROTOCOL_TYPES_OFFICE365 : PROTOCOL_TYPES;

    // FUNCTIONS
    const onProtocolChange = ({ target: { name, value } }: ChangeEvent<{ name?: string | undefined; value: unknown }>) => {
        updateState(name, value);
    };

    const openMetadata = () => {
        const url = generateAppMetadataUrl(app) ?? '';
        window.open(url, '_blank');
    };

    const generateAppMetadataUrl = (app: any) => {
        if (app) return window.location.origin + '/FederationMetadata/' + app.Id + '/xml';
        return null;
    };

    return (
        <>
            <Grid container justifyContent='space-between' className='configpanel-row'>
                <Grid item xs={12} lg={5} className='configpanel-left'>
                    <Box p={2}>
                        <form className='app-edit__form--configuration'>
                            <div className='form__row'>
                                {/* PROTOCOL_TYPE */}
                                <PasslySelect
                                    disabled={protocolTypes?.length === 0}
                                    name='Protocol'
                                    value={Protocol}
                                    id='protocolType-input'
                                    onChange={onProtocolChange}
                                    label={'APP_PROTOCOL_TYPE'}
                                    options={protocolTypes(translation)}
                                />
                            </div>
                            <ProtocolConfigurationForm setProtocolConfigError={setProtocolConfigError} />

                            {/* METADATA */}
                            {!isCustomApp(app) && (
                                <Box py={2}>
                                    <Button color='primary' variant='contained' onClick={openMetadata}>
                                        {translation('OPEN_APP_METADATA')}
                                    </Button>
                                </Box>
                            )}
                        </form>
                    </Box>
                </Grid>
                <Grid item xs={12} lg={6} className='configpanel-right'>
                    <Box p={4}>
                        {isSpInit(Protocol) && <div dangerouslySetInnerHTML={{ __html: translation('APP_PROTOCOL_SP_INIT_HELP') }}></div>}
                        {isIdPInit(Protocol) && <div dangerouslySetInnerHTML={{ __html: translation('APP_PROTOCOL_IDP_INIT_HELP') }}></div>}
                        {isOAuth(Protocol) && <div dangerouslySetInnerHTML={{ __html: translation('APP_PROTOCOL_OAUTH_HELP') }}></div>}
                        {isWSFed(Protocol) && <div dangerouslySetInnerHTML={{ __html: translation('APP_PROTOCOL_WSFED_HELP') }}></div>}
                    </Box>
                </Grid>
            </Grid>
        </>
    );
};
